export function Privacy() {
  return (
    <div className="min-h-screen bg-foretell-bg text-slate-100 p-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>

        <div className="space-y-6 text-slate-300">
          <p className="text-sm text-slate-400">Last updated: January 2025</p>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Information We Collect</h2>
            <p>When you use Foretell, we collect:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><strong>Discord Account Information:</strong> Your Discord user ID, username, avatar, and email (if authorized)</li>
              <li><strong>Server Information:</strong> Discord server IDs and names where you use the bot</li>
              <li><strong>Prediction Data:</strong> Predictions you create, votes you cast, and related metadata</li>
              <li><strong>Usage Data:</strong> How you interact with the Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Provide and maintain the Service</li>
              <li>Authenticate your identity via Discord</li>
              <li>Display your predictions and voting history</li>
              <li>Calculate and display statistics and leaderboards</li>
              <li>Improve the Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Data Storage</h2>
            <p>
              Your data is stored securely using Cloudflare's infrastructure. We use industry-standard
              security measures to protect your information. Data is stored in Cloudflare D1 databases
              with encryption at rest.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Data Sharing</h2>
            <p>We do not sell your personal information. We may share data:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>With other users as part of the Service's functionality (e.g., public predictions)</li>
              <li>With service providers who assist in operating the Service</li>
              <li>When required by law or to protect our rights</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Access your personal data</li>
              <li>Request deletion of your data</li>
              <li>Export your prediction history</li>
              <li>Revoke Discord authorization at any time</li>
            </ul>
            <p className="mt-2">
              To exercise these rights, contact us through our Discord server or GitHub repository.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Cookies and Tracking</h2>
            <p>
              We use local storage to maintain your authentication session. We do not use third-party
              tracking cookies or analytics services that track you across websites.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Children's Privacy</h2>
            <p>
              The Service is not intended for users under 13 years of age. We do not knowingly collect
              information from children under 13. If you believe we have collected such information,
              please contact us.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. International Data Transfers</h2>
            <p>
              Your data may be processed in different countries where Cloudflare operates data centers.
              By using the Service, you consent to such transfers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. We will notify users of significant changes
              through the Service or Discord.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">10. Contact Us</h2>
            <p>
              For privacy-related questions or requests, please contact us through our Discord server
              or open an issue on our GitHub repository.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
